module.exports = __webpack_public_path__ + "static/media/backhoe_tomato.69453b01.svg";